module.exports = __webpack_public_path__ + "media/Video 96.1498080a.mp4";